import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EActionTypes {
  CHECK_ESTIMATION_EXISTS_REQUEST = 'checkEstimationExistsRequest',
  CHECK_ESTIMATION_EXISTS_ERROR = 'checkEstimationExistsError',
  RESET_CHECK_ESTIMATION_EXISTS = 'resetCheckEstimationExists',
  SET_ESTIMATION_READY = 'setEstimationReady',
}

export const checkEstimationExistsRequest = actionGenerator<EActionTypes.CHECK_ESTIMATION_EXISTS_REQUEST>(
  EActionTypes.CHECK_ESTIMATION_EXISTS_REQUEST,
);

export const checkEstimationExistsRequestError = actionGenerator<EActionTypes.CHECK_ESTIMATION_EXISTS_ERROR>(
  EActionTypes.CHECK_ESTIMATION_EXISTS_ERROR,
);

export const resetCheckEstimationExists = actionGenerator<EActionTypes.RESET_CHECK_ESTIMATION_EXISTS>(
  EActionTypes.RESET_CHECK_ESTIMATION_EXISTS,
);

export interface ISetEstimationExists {
  estimationId?: number | null;
  offer?: number | null;
}
export const setEstimationReady = actionGenerator<EActionTypes.SET_ESTIMATION_READY, ISetEstimationExists>(
  EActionTypes.SET_ESTIMATION_READY,
);

export type TCheckEstimationExistsActions =
  | ReturnType<typeof checkEstimationExistsRequest>
  | ReturnType<typeof checkEstimationExistsRequestError>
  | ReturnType<typeof resetCheckEstimationExists>
  | ReturnType<typeof setEstimationReady>;
